import { Card } from "@/components/ui";

export const PostSkeleton = () => {
  return (
    <Card className="overflow-hidden rounded-3xl border border-[var(--color-mockup-border)] shadow-card">
      <div className="flex items-center gap-3 p-5">
        <div className="h-10 w-10 shrink-0 animate-pulse rounded-full bg-[var(--color-mockup-border)]" />
        <div className="min-w-0 flex-1">
          <div className="mb-1.5 h-3 w-4/5 max-w-[80%] animate-pulse rounded bg-[var(--color-mockup-border)]" />
          <div className="h-3 w-2/5 max-w-[40%] animate-pulse rounded bg-[var(--color-mockup-border)]" />
        </div>
      </div>
      <div className="h-48 animate-pulse bg-[var(--color-mockup-border)]/50" />
      <div className="flex flex-row items-center justify-between px-5 py-4 border-t border-[var(--color-mockup-border)]">
        <div className="mr-4 h-10 w-10 shrink-0 animate-pulse rounded-full bg-[var(--color-mockup-border)]" />
        <div className="h-[60px] flex-1 animate-pulse rounded-2xl bg-[var(--color-mockup-border)]/50" />
        <div className="ml-4 h-10 w-24 animate-pulse rounded-full bg-[var(--color-mockup-border)]" />
      </div>
    </Card>
  );
};

export default PostSkeleton;
